<wr-new-data-table headerText="Bereichsübersicht"
                   localStorageIdentifier="regions-overview"
                   [loadItemsFunction]="loadRegions"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToRegion($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="color"
    display="Farbe">
    <div class="color-swatch" [style.background]="region.color"></div>
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="abbreviation"
    display="Kürzel">
    @if (region.abbreviation) {
      <div>
        {{ region.abbreviation }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="name"
    display="Name">
    @if (region.name) {
      <div>
        {{ region.name }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="leader"
    exportKey="leader.fullName"
    display="Leiter*in">
    <wr-user-badge [user]="region.leader"></wr-user-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="teamCount"
    [sortable]="false"
    display="Team Anzahl">
    {{ region.teamCount }}
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="totalArea"
    [sortable]="false"
    [exportDecimals]="2"
    display="Geamtfläche">
    {{ region.totalArea | number: '1.2-2' }} m²
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="buildingCount"
    [sortable]="false"
    display="Gebäude Anzahl">
      {{ region.buildingCount }}
  </ng-template>
  <ng-template
    dataColumn
    let-region
    key="userCount"
    [sortable]="false"
    display="Benutzer Anzahl">
      {{ region.userCount }}
  </ng-template>
</wr-new-data-table>
